// TODO: move to playback

import { Map } from 'immutable';

import * as Constants from '../constants';
import { ApiActions } from '../constants/ApiActions';
import { NowPlayingKeys as keys } from '../constants/NowPlaying';
import actions from '../constants/ViewActions';
import { createReducer } from '../lib/ReducerUtils';

const INITIAL_STATE = Map({
  [keys.SESSION_HISTORY_INDEX_KEY]: 1,
  [keys.IS_SESSION_HISTORY_OPEN_KEY]: false,
  [keys.IS_NOW_PLAYING_OPEN_KEY]: false,
  [keys.IS_UPDATING_FEEDBACK_KEY]: false,
  [keys.IS_TPR_TEXT_FADED]: false,
  [keys.IS_MARKING_TRACK_AS_TIRED]: false,
});

// NOWPLAYING REDUCER
export default createReducer(INITIAL_STATE, {
  [actions.OPEN_SESSION_HISTORY]: openSessionHistory,
  [actions.TOGGLE_TPR_TEXT]: toggleTprText,
  [actions.CLOSE_SESSION_HISTORY]: closeSessionHistory,
  [actions.OPEN_NOW_PLAYING]: openNowPlaying,
  [actions.CLOSE_NOW_PLAYING]: closeNowPlaying,
  [actions.SET_SESSION_HISTORY_INDEX]: setSessionHistoryIndex,
  [ApiActions.ADD_TIRED_SONG_ATTEMPT]: addTiredSongAttempt,
  [ApiActions.ACTION_SNOOZE_ATTEMPT]: addTiredSongAttempt,
  [Constants.Playback.ActionTypes.TIRE_OF_TRACK]: tireOfTrack,
  [ApiActions.FLAG_MESSAGE_ATTEMPT]: updatingFeedback,
  [ApiActions.FLAG_MESSAGE_SUCCESS]: updatedFeedback,
  [ApiActions.FLAG_MESSAGE_FAIL]: updatedFeedback,
  [Constants.UseCases.ActionTypes.ADD_TRACK_FEEDBACK]: updatingFeedback,
  [Constants.UseCases.ActionTypes.REMOVE_TRACK_FEEDBACK]: updatingFeedback,
  [Constants.Playback.ActionTypes.TRACK_THUMBUP]: updatingFeedback, // Needed for transforming shared station optimistic UI
  [Constants.Playback.ActionTypes.TRACK_THUMBDOWN]: updatingFeedback, // Needed for transforming shared station optimistic UI
  [ApiActions.DELETE_FEEDBACK_SUCCESS]: updatedFeedback,
  [ApiActions.DELETE_FEEDBACK_FAIL]: updatedFeedback,
  [ApiActions.ADD_FEEDBACK_SUCCESS]: updatedFeedback,
  [ApiActions.ADD_FEEDBACK_FAIL]: updatedFeedback,
  [ApiActions.ACTION_THUMB_UP_SUCCESS]: updatedFeedback,
  [ApiActions.ACTION_THUMB_UP_FAIL]: updatedFeedback,
  [ApiActions.ACTION_THUMB_DOWN_SUCCESS]: updatedFeedback,
  [ApiActions.ACTION_THUMB_DOWN_FAIL]: updatedFeedback,
  [ApiActions.ACTION_REMOVE_THUMB_SUCCESS]: updatedFeedback,
  [ApiActions.ACTION_REMOVE_THUMB_FAIL]: updatedFeedback,
});

// CASE FUNCTIONS

function openSessionHistory(state, action) {
  return state.merge({
    [keys.IS_SESSION_HISTORY_OPEN_KEY]: true,
    [keys.SESSION_HISTORY_INDEX_KEY]: action.historySize - 2,
  });
}

function toggleTprText(state, action) {
  return state.set(keys.IS_TPR_TEXT_FADED, action.data.isFaded);
}

function closeSessionHistory(state) {
  return state.set(keys.IS_SESSION_HISTORY_OPEN_KEY, false);
}

function openNowPlaying(state) {
  return state.set(keys.IS_NOW_PLAYING_OPEN_KEY, true);
}

function closeNowPlaying(state) {
  return state.set(keys.IS_NOW_PLAYING_OPEN_KEY, false);
}

function setSessionHistoryIndex(state, action) {
  return state.set(keys.SESSION_HISTORY_INDEX_KEY, action.sessionHistoryIndex);
}

function addTiredSongAttempt(state) {
  return state.set(keys.IS_MARKING_TRACK_AS_TIRED, true);
}

function tireOfTrack(state) {
  return state.set(keys.IS_MARKING_TRACK_AS_TIRED, false);
}

function updatingFeedback(state) {
  return state.set(keys.IS_UPDATING_FEEDBACK_KEY, true);
}

function updatedFeedback(state) {
  return state.set(keys.IS_UPDATING_FEEDBACK_KEY, false);
}
